import { createFileRoute } from "@tanstack/react-router";
import { Container, Typography, Box, CircularProgress } from "@mui/material";
import PublicProjectForm from "@/components/PublicProjectForm";
import { fetchProjectByAlias, submitPublicForm } from "@/api/projectsApi";
import { useQuery } from "@tanstack/react-query";

export const Route = createFileRoute("/p/$alias")({
  component: RouteComponent,
});

function RouteComponent() {
  const { alias } = Route.useParams();

  const {
    data: project,
    isLoading: projectLoading,
    error: projectError,
  } = useQuery({
    queryKey: ["project-by-alias", alias],
    queryFn: () => fetchProjectByAlias(alias as string),
  });

  const handleSubmit = async (formData: Record<string, string>) => {
    if (!project?.id) return;
    await submitPublicForm(project.id, formData);
  };

  if (projectLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (projectError || !project) {
    return (
      <Container maxWidth="md">
        <Typography variant="h5" color="error" align="center">
          {projectError instanceof Error
            ? projectError.message
            : "Project not found"}
        </Typography>
      </Container>
    );
  }

  return <PublicProjectForm project={project} onSubmit={handleSubmit} />;
}
